import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-background-200/70 bg-background-50">
      <div className="px-4 md:px-10 lg:px-14 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-foreground-600">
          © 2026 Hearth &amp; Heirloom
        </p>
        <div className="flex items-center gap-6 text-xs text-foreground-700">
          <Link to="/#collections" className="hover:text-foreground-950 cursor-pointer">Shop</Link>
          <Link to="/artisans" className="hover:text-foreground-950 cursor-pointer">Artisans</Link>
          <a href="mailto:hello@hearth.shop" className="hover:text-foreground-950 cursor-pointer">Contact</a>
        </div>
      </div>
    </footer>
  );
}